/** 
 * Enumeration des types d'objets de base existants dans Dcx
 * @description BaseObjectTypeEnum contient uniquement les valeurs de base d'ObjetTypeEnum issu de Dcx.kernel
 */
enum BaseObjectTypeEnum {
	Root = 'Root',
	None = 'None',
	Any = 'Any',
	BusinessObject = 'BusinessObject',
	LocalisedObject = 'LocalisedObject',
	Client = 'Client',
	Equipment = 'Equipment',
}

export default BaseObjectTypeEnum;